import { render, staticRenderFns } from "./BuyerSpaceDocs.vue?vue&type=template&id=bfd0daec&"
import script from "./BuyerSpaceDocs.vue?vue&type=script&lang=js&"
export * from "./BuyerSpaceDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports